<template>
<div>
  <div class="row">
    <div class="col-12">
      <router-link :to="{ name:'PlaylistsAdd' }" class="btn btn-success"><i class="fa fa-edit" aria-hidden="true"></i>
        Add Playlist
      </router-link>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-8">
      <table class="table table-striped">
        <thead class="bg-hub-primary text-white">
        <tr>
          <th>Name</th>
          <th>Items</th>
          <th>Manage</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="playlist in filtered_playlists" :key="playlist.playlist_id">
          <td>{{ playlist.name }}</td>
          <td class="d-none d-md-table-cell" v-if="playlist.playlist_items.length > 0">
            <button type="button" class="btn btn-light"
            @click="toggle_playlist_items(playlist.playlist_id)">{{ ((playlists_showing_items.includes(playlist.playlist_id)) ? 'Hide' : 'Show') }} Items
            </button>
            <div v-if="playlists_showing_items.includes(playlist.playlist_id)">
              <br>
              <table class="table">
                <tbody>
                  <tr v-for="playlist_item in playlist.playlist_items"
                    :key="playlist_item.playlist_item_id">
                    <td>
                      {{ playlist_item.order }}
                    </td>
                    <td>
                      {{ playlist_item.sound.filename }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td class="d-none d-md-table-cell" v-else>No devices assigned</td>
          <td>
            <div class="dropdown">
              <button class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <router-link :to="{ name:'PlaylistsEdit', params: { playlist_id: playlist.playlist_id } }"
                             class="dropdown-item"><i
                  class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i>&nbsp;Edit
                </router-link>
                <a class="dropdown-item" href="#" onclick="return false" @click="deletePlaylist(playlist)"><i
                  class="fa fa-trash fa-fw"
                  aria-hidden="true"></i>&nbsp;Delete</a>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data: function () {
    return {
      playlists_showing_items: []
    }
  },
  computed: {
    ...mapGetters({
      playlists: 'allPlaylists',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_playlists: function () {
      return this.playlists.filter(playlist => playlist.site_id === this.scoped_site_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getPlaylists')
  },
  methods: {
    ...mapActions([
      'deletePlaylist'
    ]),
    toggle_playlist_items (playlistId) {
      if (this.playlists_showing_items.includes(playlistId)) {
        this.playlists_showing_items.splice(this.playlists_showing_items.indexOf(playlistId), 1)
      } else {
        this.playlists_showing_items.push(playlistId)
      }
    }
  }
}
</script>

<style scoped>

</style>
